import { annotationsSchema } from 'components/ChartTools/Annotations/schema';
import {
  CHART_VIEW_SETTINGS_TYPE,
  CHART_VIEW_SETTINGS_FULL_NAME,
} from 'components/ChartTools/ViewSettings/constants';
import { viewSettingsSchema } from 'components/ChartTools/ViewSettings/schema';

import { object } from '@gogame/schemas';

import { chartSettingsSchema } from './chartSettingsSchema';
import { columnsSchema } from './columnsSchema';
import { hiddenSchema } from './hiddenSchema';
import { periodSchema } from './periodSchema';
import { seriesSchema } from './seriesSchema';

export const presetSchema = object({
  period: periodSchema,
  series: seriesSchema,
  annotations: annotationsSchema.namespace('annotations'),
  chartViewSettings: viewSettingsSchema
    .default({
      ...viewSettingsSchema.default(),
      [CHART_VIEW_SETTINGS_TYPE]: 'line',
      [CHART_VIEW_SETTINGS_FULL_NAME]: true,
    })
    .namespace('chartViewSettings'),
  chartSettings: chartSettingsSchema,
  hidden: hiddenSchema,
  columns: columnsSchema,
});

export const mapStateToPreset = screenState =>
  presetSchema.stripDefaults().cast(screenState, {
    applyConst: true,
    stripUnknown: true,
  });
